import React from "react";
import {
  Row,
  Col,
  ListGroup,
  ListGroupItem,
  FormGroup,
  Label
} from "reactstrap";

import Channel from "./Channel";
import { channelTypes, channelStatus, channelCountries } from "./constants";
import RadioButtonGroup from "../Form/RadioButtonGroup";
import Input from "../Form/Input";

class Channels extends React.PureComponent {
  constructor(props) {
    super();
    this.state = {
      filteredChannels: Object.values(props.channels) || [],
      filters: {}
    }
  }
  doFilter = (channels, filters) => {
    let result = [...channels];
    Object.keys(filters).forEach(key => {
      if (key === 'text') {
        result = result.filter(item => JSON.stringify(item).indexOf(filters[key]) > -1)
      } else if (filters[key]) {
        result = result.filter(item => item[key] === filters[key])
      }
    })
    return result;
  }
  componentWillReceiveProps(nextProps) {
    if (
      (nextProps.channels && !this.props.channels) ||
      (Object.keys(nextProps.channels).length !== Object.keys(this.props.channels).length)
    ) {
      this.setState({ filteredChannels: this.doFilter(nextProps.channels, this.state.filters) })
    }
  }
  render() {
    const { channels, onDelete, ...rest } = this.props;
    return (
      <div>
        <Row>
          <Col>
            <FormGroup>
              <Label>جستجو با متن</Label>
              <Input
                bsSize="sm"
                input={{
                  value: this.state.filters.text,
                  onChange: e => {
                    this.setState({ filters: { ...this.state.filters, text: e.target.value } });
                    return this.setState({ filteredChannels: this.doFilter(channels, { ...this.state.filters, text: e.target.value }) })
                  }
                }}
              />
            </FormGroup>
          </Col>
          <Col>
            <FormGroup>
              <Label>نوع کانال</Label>
              <RadioButtonGroup
                size="sm"
                options={channelTypes}
                clearButtonLabel="همه"
                input={{
                  value: this.state.filters.type,
                  onChange: value => {
                    this.setState({ filters: { ...this.state.filters, type: value } });
                    return this.setState({ filteredChannels: this.doFilter(channels, { ...this.state.filters, type: value }) })
                  }
                }}
              />
            </FormGroup>
          </Col>
          <Col>
            <FormGroup>
              <Label>وضعیت کانال</Label>
              <RadioButtonGroup
                size="sm"
                options={channelStatus}
                clearButtonLabel="همه"
                input={{
                  value: this.state.filters.status,
                  onChange: value => {
                    this.setState({ filters: { ...this.state.filters, status: value } });
                    return this.setState({ filteredChannels: this.doFilter(channels, { ...this.state.filters, status: value }) })
                  }
                }}
              />
            </FormGroup>
          </Col>
          <Col>
            <FormGroup>
              <Label>کشور</Label>
              <RadioButtonGroup
                size="sm"
                options={channelCountries}
                canToggle
                input={{
                  value: this.state.filters.country || null,
                  onChange: value => {
                    this.setState({ filters: { ...this.state.filters, country: value } });
                    return this.setState({ filteredChannels: this.doFilter(channels, { ...this.state.filters, country: value }) })
                  }
                }}
              />
            </FormGroup>
          </Col>
        </Row>
        <ListGroup flush {...rest}>
          {this.state.filteredChannels.map(channel => (
            <ListGroupItem action key={channel.id} className="p-0">
              <Channel channel={channel} onDelete={onDelete} className="p-3" actions />
            </ListGroupItem>
          ))}
        </ListGroup>
      </div>
    )
  }
}


export default Channels;